import { z } from 'zod';

export const EmailAttachment = z.object({
  url: z.string(),
  fileName: z.string(),
});
